<template>
    <div class='powerhours-graph-filter'>
        <div class="row" v-if="loaded">
            <div class="col-12">
                <el-card class="box-card">
                    <div class="row mobile-center">
                        <div class="col-8 vertical-center">
                            <el-select
                                v-model="managers"
                                filterable
                                :clearable=true
                                multiple
                                collapse-tags
                                placeholder="Filter managers"
                                @visible-change="managerFilterChange($event)"
                                class="fl">
                                <el-option
                                    v-for="item in $store.getters['general/getStoreInterests']"
                                    :key="item.user_id"
                                    :label="item.user_name"
                                    :value="item.user_id">
                                </el-option>
                            </el-select>

                            <el-select
                                v-model="stores"
                                filterable
                                :clearable=true
                                collapse-tags
                                multiple
                                class="store-selector fl ml-5-howrly"
                                placeholder="Filter stores"
                                @visible-change="filterChange($event)"
                                @change="checkSelect($event)">
                                <el-option
                                    label="All stores"
                                    value="all">
                                </el-option>
                                <el-option
                                    label="No stores"
                                    value="none">
                                </el-option>
                                <el-option
                                    v-for="item in $store.getters['general/getStores']"
                                    :key="item.store_id"
                                    :label="item.store_name"
                                    :value="item.store_id">
                                </el-option>
                            </el-select>
                        </div>
                        <!-- <div class="col-xl-4 col-12 filter-right">
                            <el-radio-group v-model="$store.state.graphFilter.powerhoursSwitch" @change="$emit('switchChange')" size="medium" class="vertical-center switch-right ml-5-howrly">
                                <el-radio-button label="Diff"></el-radio-button>
                                <el-radio-button label="Prod"></el-radio-button>
                                <el-radio-button label="Score"></el-radio-button>
                            </el-radio-group>
                        </div> -->
                    </div>
                </el-card>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <el-card class="box-card" style="height: 80px;">
                    <div class="card-body no-padding"></div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
var debounce = require('debounce')
export default {
    data () {
        return {
            loaded: false,
            managers: [],
            stores: [101],
            period: new Date(),
            period2: new Date()
        }
    },
    components: {
    },
    computed: {

    },
    methods: {
        getQueryParameters () {
            for (let param in this.$route.query) {
                if (param === 'store') {
                    this.store = parseInt(this.$route.query[param])
                    this.filterChange(true)
                }

                // Delete param from the url
                let query = Object.assign({}, this.$route.query)
                delete query[param]
                this.$router.replace({ query })
            }
        },
        debounceInput: debounce(
            function () {
                let storeList = this.stores
                this.$emit('filterChanged', { 'stores': storeList })
            }, 500),
        filterChange (event) {
            if (event !== true) { // In this case the change is not submitted by the user yet
                this.debounceInput()
            }
        },
        managerFilterChange (event) {
            if (event === false) { // This means the modal is closed, so we want to reload the
                let data = []
                for (let m of this.managers) {
                    let stores = this.$store.state.general.storeInterests.find(x => x.user_id === m)['stores']
                    if (stores !== null && stores.length > 0) {
                        data.push(...stores)
                    }
                }
                data = Array.from(new Set(data))
                console.log(data)
                this.stores = data
                this.emitFilterChange()
            }
        },
        checkSelect (stores) {
            if (stores.includes('all')) {
                this.stores = this.$store.getters['general/getStores'].map(s => s.store_id)
            } else if (stores.includes('none')) {
                this.stores = []
            }
        },
        emitFilterChange () {
            this.debounceInput()
        }
    },
    created () {
        let promiseList = [this.$store.dispatch('general/getStores'), this.$store.dispatch('general/getStoreInterests')]
        Promise.all(promiseList).then(response => {
            this.stores = this.$store.state.general.storeInterests.find(x => x.user_id === parseInt(localStorage.getItem('user_id')))['stores']
            this.managers = [parseInt(localStorage.getItem('user_id'))]
            this.$store.commit('graphFilter/SET_POWER_HOURS_SELECTED_STORE', this.stores[0])
            this.getQueryParameters()
            this.loaded = true
            this.$emit('filterLoaded', { 'stores': this.stores })
        })
    }
}
</script>

<style lang="scss">
.powerhours-graph-filter {
    .store-selector, .range-selector, .date-editor-button-plus, .date-editor-button-minus {
        float: left;
    }
    .range-selector {
        margin-left: 0px;
    }
    .el-select {
        width: 250px;
    }
    .el-date-editor {
        width: 150px;
    }
    .range-selector {
        width: 100px;
    }
    .date-editor-button-plus {
        border-radius: 0;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-left: none;
    }
    .date-editor-button-minus {
        border-radius: 0;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-right: none;
    }
    .date-editor-button-minus:hover {
        background-color: #fff;
    }
    .date-editor-button-plus:hover, .date-editor-button-plus:active , .date-editor-button-plus:focus, .date-editor-button-minus:hover, .date-editor-button-minus:active , .date-editor-button-minus:focus {
        background-color: #fff;
        border-color: #DCDFE6;
        outline: none !important;
        box-shadow: none !important;
        color: #606266;
    }
    .date-editor-button-plus:hover, .date-editor-button-minus:hover {
        color: #409EFF;
    }
    .el-date-editor {
        .el-input__inner {
            border-radius: 0;
        }
        .el-input__inner:focus, .el-input__inner:hover {
            border-color: #DCDFE6;
        }
    }
    @media(max-width: 768px) {
        .date-editor-button-minus, .date-editor-button-plus {
            display: none !important;
        }
        .range-selector {
            margin-left: 10px;
        }
        .el-date-editor {
            .el-input__inner {
                border-radius: 5px;
            }
        }
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 180px;
    }
    @media(max-width: 768px) {
        .range-selector {
            margin-top: 10px;
            margin-left: 0px;
        }
        .el-date-editor {
            .el-input {
                border-radius: 5px;
                width: 200px !important;
            }
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 200px;
        }
    }
    .el-radio-group {
        float: left;
        margin-top: 10px;
    }
    @media(min-width: 600px) {
        .el-radio-group {
            float: right;
            margin-top: 0px;
        }
    }
}
</style>
